<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="系统日志详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="名称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.name" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="日志级别" class="detail-form-item">
                  <el-input size="medium" v-model="entity.logLvel" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="操作人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="操作时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="日志内容" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.logInfo" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { SystemLog } from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { SystemLogService } from "@/script/apps/system/service/SystemLogService";
import { ElMessage } from "element-plus";

@Options({})
export default class SystemLogDetail extends BaseDetail {
  private service = new SystemLogService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "sys_log",
      "/sys/system_log",
      "/sys/system_log",
      this.service
    );
  }  

  public newEntity() {
    const entity: SystemLog = {};
    return entity;
  }
}
</script>

<style lang="scss">
</style>
